export function useFileOperations() {
  const downloadFiles = (chatId: string | undefined) => {
    if (!chatId) {
      console.error("No chat ID available");
      return;
    }
    const downloadUrl = `/api/chats/${chatId}/files/download`;
    window.location.href = downloadUrl;
  };

  return {
    downloadFiles,
  };
}
